import React, {useContext} from 'react';
import {Modal, Button} from 'antd';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {deleteGroup} from "../api";
import {Store} from "../state_store/provider";
import {GROUP} from "../state_store/actionType";
import {Request} from "../utils";

export default function CompanyDelete(props) {
    const {open, onClose, onOK, data} = props
    const {state, dispatch} = useContext(Store)
    const onDelete = ()=>{
        const id = data.id
        Request(dispatch, deleteGroup(id), onOK).then(error=>{
            if(!error){
                const group = state.group.filter(res => res.id !== id)
                dispatch({type: GROUP, payload: group})
            }
        })
        // deleteGroup(id).then(res=>{
        //     if (res.result === 0) {
        //         const group = state.group.filter(res => res.id !== id)
        //         dispatch({type: GROUP, payload: group})
        //         onOK()
        //     }
        // })
    }

    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>


                <div className={"delete-dialog-body column center"}>
                    <div className={"icon"}>
                        <ExclamationCircleOutlined/>
                    </div>
                    <div className={"title"}>グループを削除</div>
                    <div className={"subtitle"}>
                        このグループに関連する情報が失われます。
                    </div>
                    <div className={"subtitle"}>
                        削除してよろしいですか？
                    </div>

                </div>
                <div className={"delete-dialog-footer row center"}>
                    <Button type="primary" style={{backgroundColor:"#606060"}}
                            onClick={onClose}
                    >キャンセル</Button>
                    <Button
                        onClick={onDelete}
                        type="primary" style={{backgroundColor:"#377EF3"}}>削除する</Button>
                </div>
            </div>
        </Modal>
    );
};
